import SearchLocation from "../SearchLocation";
import {RoutesSearch} from "../search/RoutesSearch";
import Filters from "./Filters";

window.routesSearchInit = function(){

    let form = $('form.routesSearchForm');
    let filterContainer = form.find('.routesSearchForm-filter');

    let coordinates_input = form.find('input[name=coordinates]');
    let country_id = form.find('input[name=country_id]');
    let state_id = form.find('input[name=state_id]');
    let city_id = form.find('input[name=city_id]');

    let findLocation = form.find('input[name=findLocation]');

    (new SearchLocation({
        gallery: {
            withCountRoutes: true,
            whereCountRoutes: true
        },
        triggerUpdateName: 'RoutesSearchLocation.update'
    })).init(findLocation.val().length > 0);
    const filters = new Filters(filterContainer);
    filters.render();

    form.on('submit', function(e){
        e.preventDefault();
        e.stopPropagation();
    })

    $(document).on('RoutesSearchForm.update', function(){
        RoutesSearch('.routesSearchForm');
    })

    $(document).on('RoutesSearchLocation.update', function(e, payload){

        coordinates_input.val('');
        country_id.val('');
        state_id.val('');
        city_id.val('');

        if(payload){
            switch(payload.type){
                case 'coordinates':
                    coordinates_input.val(payload.coordinates.lat+','+payload.coordinates.lng);
                    filters.showRadius();
                    break;
                case 'city':
                    filters.showRadius();
                    city_id.val(payload.id);
                    break;
                case 'country':
                    country_id.val(payload.id);
                    filters.hideRaius();
                    break;
                case 'state':
                    state_id.val(payload.id);
                    filters.hideRaius();
                    break;
            }
        }else{
            filters.hideRaius();
        }

        $(document).trigger('RoutesSearchForm.update');

    })


}

window.addEventListener('load', function(){
    window.routesSearchInit();
})